export default {

  dbh_login_image_title: '为 您 呈 现 海 量{br}全 球 游 戏 市 场 数 据',
  dbh_login: '登录',
  dbh_login_goback_tologin: '返回登录',
  dbh_login_continue: '继续',

  // index
  dbh_login_OA: 'OA登录',
  dbh_login_account: '账户登录',
  dbh_login_email: '邮箱登录',
  dbh_login_email_placeholder: '请输入邮箱',
  dbh_login_other_methods: '或者',
  dbh_login_email_desc: `当前数据大脑海外访问链接仅供没有OA账户或者不在中国的用户使用，用户可使用数据大脑账号登录；  使用腾讯OA的用户请访问：`,
  dbh_login_contact_ivyyfchen: '如对数据大脑账号有疑问，请联系 ',

  // 账号登陆
  dbh_login_account_login: '数据大脑账户登录',
  dbh_login_account_name: '账户名称',
  dbh_login_account_name_placeholder: '请输入账户名称',
  dbh_login_email_login: '数据大脑邮箱登录',
  dbh_login_password: '密码',
  dbh_login_password_placeholder: '请输入密码',
  dbh_login_email_password_placeholder: '请输入长度在4到14字符之间的密码',
  dbh_login_register: '注册',
  dbh_login_forget_password: '忘记密码',
  dbh_login_is_forget_password: '修改/忘记密码',
  dbh_login_forget_password_desc: '请联系{name}重新获取您的用户名及密码信息',
  dbh_login_ikonw: '我知道了',

  // 忘记密码
  dbh_login_password_reset_link: '密码重置链接已发送',
  dbh_login_password_reset_link_desc: '我们已将操作说明以邮件的方式发送给您。请您打开收件箱，单击里面的链接来重置您的密码。',
  dbh_login_didnot_receive_email: '没有收到来着数据大脑的邮件',
  dbh_login_resend_confirm: '重发确认电子邮件',
  dbh_login_forget_emailpassowrd_desc: `忘记了密码？请在下方输入您的邮箱地址，我们会以邮件的方式为您发送设置新密码的方法。`,
  dbh_login_send_code: '发送验证码',
  dbh_login_send_new_code: '重新发送',
  dbh_login_verify: '验证',
  dbh_login_code_send_success: '验证码发送成功',
  dbh_login_please_enter_emailed: '请输入下方邮箱收到的验证码：',
  dbh_login_code_expires_after: '验证码在以下时间失效',// TODO
  dbh_login_enter_access_code: '请输入验证码',

  dbh_login_please_enter_occupation: '请选择岗位',
  dbh_login_please_enter_unentered_position: '未选择岗位',

  dbh_login_others: '其他',
  dbh_login_no_data: '暂无数据',
  dbh_login_occupation: '用户岗位',
  dbh_login_signup_for_free: '免费注册',
  dbh_login_word_email: '工作邮箱',
  dbh_login_word_email_placeholder: '请输入工作邮箱',
  dbh_login_password_confirm: '密码确认',
  dbh_login_password_confirm_placeholder: '请再次输入密码',
  dbh_login_reason_forapp: '申请原因',
  dbh_login_reason_forapp_placeholder: '请说明申请原因',

  // 注册成功
  dbh_login_thankyou_register: '感谢您注册数据大脑!',
  dbh_login_click_email_link_desc: `我们稍后会向您发送确认电子邮件，请您打开收件箱，单击里面的链接登录数据大脑。`,
  dbh_login_register_contant_desc: '如有任何疑问，请联系ivyyfchen@tencent.com。',
  dbh_login_register_fail_oa_part1: 'OA用户请返回 ',
  dbh_login_register_fail_oa_part2: '登录页',
  dbh_login_register_fail_oa_part3: ' 选择OA登录',

  // 重置密码
  dbh_login_reset_passwords: '重置密码',
  dbh_login_reset_email_success: '邮箱登录密码重置成功',

  // 错误提示
  dbh_login_no_account_enter: '未输入账户名称',
  dbh_login_account_format_gsv: `请输入字母，数字，以及“_”（下划线）的组合，特殊字符例如 ', ", --, /* */不允许使用。`,
  dbh_login_format_gsv: `特殊字符例如 ', ", --, /* */不允许使用。`,
  dbh_login_no_password_enter: '未输入密码',
  dbh_login_incorrect_username: '账户名称错误',
  dbh_login_incorrect_password: '密码错误',
  dbh_login_no_email_entered: '未输入邮箱',
  dbh_login_no_work_email_entered: '未输入邮箱',
  dbh_login_incorrect_email: '邮箱错误',
  dbh_login_no_reason_enter: '未输入申请原因',
  dbh_login_more_reason_enter: '超过500个字符',
  dbh_login_different_passwords: '密码不一致',
  dbh_login_password_format: '密码需要包含{min}~{max}个字符',
  dbh_login_email_format_error: '邮箱格式错误',
  dbh_login_incorrenct_code_try_again: '验证码错误，请重试',
  dbh_login_no_access_code: '未输入验证码',
  dbh_login_no_access_code_format_error: '验证码格式错误',// TODO
  dbh_login_error_no_message: ' ',
  dbh_login_error_username: '账户名称或密码错误，请重试。',
  dbh_login_error_email: '邮箱或密码错误，请重试。',

  // 错误弹框提示
  dbh_login_oa_login_failed: '系统未识别到腾讯OA，请使用账号密码或SSO登陆',
  dbh_login_email_password_timeout: '密码重置错误或超时，请重试',
  dbh_login_email_sent_5times_err: '电子邮件验证码每 1 小时只能发送 5 次，请稍后重试',
  dbh_login_user_not_or_password_wrong: '用户不存在或密码错误',
  dbh_login_login_errors_5_times: '登录错误次数为每30分钟5次，请稍后再试。',
  dbh_login_account_or_email_not: '帐户名或电子邮件不存在。',
  dbh_login_network_error: '网络连接错误，请检查网络',
  dbh_login_email_exist: '邮箱已存在',
  dbh_login_5times_err: '登陆错误次数每 30 分钟 5 次，请稍后重试',

  dbh_login_organization: '组织',
  dbh_login_select_organization: '请选择组织',
  dbh_login_register_format_err: '暂不支持当前邮箱后缀注册，请联系DataBrain助手',

  dbh_14_days_login: '在14天之内记住我',
  dbh_login_type_google: '使用Google登录',
  dbh_login_type_google_tip: '需使用公司邮箱登陆Google',
  dbh_login_type_sso: '使用{type}登录',
  dbh_login_google_email_fail: '抱歉，用户不存在',
  dbh_login_google_email_fail_tip: '请使用您的公司邮箱后缀登录Google，如有任何问题请联系',
  dbh_login_get_google_msg_fail: '从{provider}获取用户信息失败',
  dbh_login_get_google_msg_fail_tip: '请返回重试，如有任何问题请联系',
  dbh_login_database_query_fail: '数据库查询故障',
  dbh_login_database_query_fail_tip: '数据库查询时出现错误，如需进一步的帮助，请联系',
  dbh_login_account_creation_fail: '新账号创建失败',
  dbh_login_account_creation_fail_tip: '创建新账号失败，如需进一步的帮助，请联系',
  dbh_login_server_error_fail: '服务器错误',
  dbh_login_server_error_fail_tip: '服务器运行时发生了错误，为了解决这个问题，我们非常感谢您的反馈，请联系',
  dbh_login_google_network_fail: '网络异常',
  dbh_login_google_network_fail_tip: '请检查网络后再重试，如有任何问题请联系',
  dbh_login_choose_company_require: '请选择公司',
  dbh_login_last_login: '上次登录',
  dbh_login_agent_robot_tip: 'Hi! 我是您的专属游戏数据AI Agent',
  dbh_login_agent_robot_tip_sub: '想了解今日游戏表现，一问便知',
  dbh_login_robot_hover: '点击前往DataBrain Agent',
  dbh_login_arrow_collapse: '点击以收起',
  dbh_login_arrow_expand: '点击以展开',

};
